// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 用户行为上报 POST /user/customer_track/upload/enven */
export async function userCustomerTrackUploadEnvenUsingPOST(
  body: API.CreateTrackEventReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/user/customer_track/upload/enven', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户心跳上报 POST /user/customer_track/upload/heartbeat */
export async function userCustomerTrackUploadHeartbeatUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.userCustomerTrackUploadHeartbeatUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/user/customer_track/upload/heartbeat', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
